import { ToastPosition } from "react-toastify";
import moment from 'moment'
class Helper {
	static toCamelCase = (name: string = '') => {
		return name !== '' && name?.replace(
			/\w\S*/g,
			function (txt) {
				return txt.charAt(0).toUpperCase() + txt.slice(1);
			}
		);
	}

	static getError = (error: any) => {
		return error?.payload?.response?.data?.error?.message || error?.payload?.message || error?.error?.message || 'Unknown Error';
	}

	static bottom_center = () => {
		return {
			position: 'bottom-center' as ToastPosition,
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
		}
	}

}

export default Helper